import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { yearEndChart, yearEndPerformance } from './game';
import { GameComponentService } from './gameComponent.service';
import { Subscription }   from 'rxjs/Subscription';

@Component({
  selector: 'last-year',
  templateUrl: './last-year.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LastYearComponent implements OnInit, OnDestroy {

  public _results = '';
  GCSfooter: Subscription;
  GCSyearStarted: Subscription;
  GCSgridData: Subscription;
  GCSchartLegend: Subscription;
  GCSchartData: Subscription;
  GCSperfYours: Subscription;
  GCSperfBank: Subscription;  
  
	@ViewChild('lastYear') lyTab;
  @ViewChild('lyContent') lyContent;
  @ViewChild('yearTab') lyTabHead: ElementRef;
  
  public chartDataYear1: number[];
  public chartDataYear2: number[];
  public chartDataYear3: number[];
  public chartDataYear4: number[];
  public chartLegendYear1: string;
  public chartLegendYear2: string;
  public chartLegendYear3: string;
  public chartLegendYear4: string;
  public gridData: yearEndChart[];
  public performanceYours: yearEndPerformance;
  public performanceBank: yearEndPerformance;

  constructor(element:ElementRef, public _srvc: GameComponentService) {
    //console.log("LY construct");
  }

  private _visible:boolean = false;  
  public graph:boolean = false;


  public yieldClicked(event){
    console.log("yieldClicked : this.graph : " + this.graph);
    this.graph = !this.graph;
    //console.log(this.graph);
    //console.log('lyTab')
    //console.log(this.lyTab);
  }  

  public showTab(event) {
    this._srvc.SetFooterOpen(event);
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.GCSfooter = this._srvc.ShowFooter$.subscribe(
      res => {
        //console.log("LY ShowFooter Update: " + res);
        this._visible = res;
      },
      err => console.log("sub error: " + err),
    );
    this.GCSyearStarted = this._srvc.YearStarted$.subscribe(
      res => {
        //console.log("LY YearStarted Update: " + res);
        //this._visible = res;

        if(!res) {
          if (!this.lyTab.selected){
            this.lyTabHead.nativeElement.click();
            this._srvc.SetFooterOpen(true);
          }
          this.lyTab.disabled = true;
        }
        else if(res) {
          this.lyTab.disabled = false;
          if (this.lyTab.selected){
            this.lyTabHead.nativeElement.click();
            this._srvc.SetFooterOpen(false);
          }
        }

      },
      err => console.log("sub error: " + err),
    );
    this.GCSgridData = this._srvc.FooterGrid$.subscribe(
      res => {
        //console.log("LY FooterGrid Update: " + res);
        this.gridData = res;
      },
      err => console.log("sub error: " + err),
    );
    this.GCSchartLegend = this._srvc.FooterLegend$.subscribe(
      res => {
        //console.log("LY FooterChartLegend Update: " + res);
        if (res.length >= 1) {
          this.chartLegendYear1 = res[0];
          if (res.length >= 2) {
            this.chartLegendYear2 = res[1];
            if (res.length >= 3) {
              this.chartLegendYear3 = res[2];
              if (res.length >= 4) {
                this.chartLegendYear4 = res[3];
              }
            }
          }
        }
      },
      err => console.log("sub error: " + err),
    );
    this.GCSchartData = this._srvc.FooterData$.subscribe(
      res => {
        //console.log("LY FooterChart Update: " + res);
        // console.log("**********");
        // console.log(res);
        // console.log("**********");
        if (res.length >= 1) {
          this.chartDataYear1 = res[0];
          if (res.length >= 2) {
            this.chartDataYear2 = res[1];
            if (res.length >= 3) {
              this.chartDataYear3 = res[2];
              //this.graph = true;
              if (res.length >= 4) {
                this.chartDataYear4 = res[3];
              }
              else {
                this.chartDataYear4 = null;
              }
            }
            else {
              this.chartDataYear3 = null;
            }
          }
          else {
            this.chartDataYear2 = null;
            this.chartDataYear3 = null;
          }
          this.graph = true;
        }
        else {
          this.chartDataYear1 = null;
          this.chartDataYear2 = null;
          this.chartDataYear3 = null;
          this.chartDataYear4 = null;
        }
      },
      err => console.log("sub error: " + err),
    );
    this.GCSperfYours = this._srvc.PerfYours$.subscribe(
      res => {
        //console.log("LY PerfYours Update: " + res);
        this.performanceYours = res;
      },
      err => console.log("sub error: " + err),
    );
    this.GCSperfBank = this._srvc.PerfBank$.subscribe(
      res => {
        //console.log("LY PerfBank Update: " + res);
        this.performanceBank = res;
      },
      err => console.log("sub error: " + err),
    );
  }

  ngOnDestroy() {
    try {
      this.GCSfooter.unsubscribe();
      this.GCSyearStarted.unsubscribe();
      this.GCSgridData.unsubscribe();
      this.GCSchartData.unsubscribe();
      this.GCSchartLegend.unsubscribe();
      this.GCSperfYours.unsubscribe();
      this.GCSperfBank.unsubscribe();
		}
		catch (ex) {
		
		}      
	}
}



// WEBPACK FOOTER //
// ./src/app/game/last-year.component.ts